export { default as DotsHorizontalSolidIcon } from './DotsHorizontalSolidIcon';
